import React from 'react';
import {ROLES, withRoles} from "./Permissions";

const Home = () => (
    <div>
        <h2>Home</h2>
        <div>Welcome to the Reviewer application. Please use any available menu above. More description would follow.</div>
    </div>
);

export default withRoles([ROLES.COORDINATOR,ROLES.DEPARTMENTCOORDINATOR, ROLES.ADMIN, ROLES.REVIEWER])(Home);
